// extracted by mini-css-extract-plugin
module.exports = {"base":"LinkAddon-module-base"};